import { Injectable } from "@angular/core";
import { DbQueryService } from "./db-query.service";

/**
 * Tracks QuickBooks connectivity state across pages that need to gate actions
 * on a healthy QBO connection (End of Day, Account-Owned Invoices, Manifest Groups, ...).
 *
 * Pages inject this service, call `refresh()` on init / before destructive actions,
 * and bind buttons to `isQbHealthy`. The banner component renders the spinner /
 * error / hidden states off the same flags.
 */
@Injectable({ providedIn: "root" })
export class QbHealthService {
  /** Last error message from `checkQuickbooksSetup`. Null when healthy. */
  qbHealthMessage: string | null = null;
  isQbHealthy = false;
  /** True while a `refresh()` is in flight. */
  isCheckingQb = false;

  constructor(private dbQueryService: DbQueryService) {}

  /** Run the health check. Returns `true` when QBO is healthy. */
  async refresh(): Promise<boolean> {
    this.isCheckingQb = true;
    try {
      const msg = await this.dbQueryService.checkQuickbooksSetup();
      this.qbHealthMessage = msg;
      this.isQbHealthy = msg === null;
      return this.isQbHealthy;
    } finally {
      this.isCheckingQb = false;
    }
  }
}
